<template>
    <div class="winner-head-nav-bar">
        <div class="nv-wrapper theme-bg-color">
            <div class="nv-back" @click="clickBack"></div>
            <div class="nv-name">
                <div>{{pageName}}</div>
                <div class="headline-winner">
                    <div class="image"><img :src="imageUrl" class="img-fluid"/></div>
                    <div class="name">{{title}}</div>
                </div>
            </div>
        </div>
        <div class="nv-wrapper-bottom" :class="{'nav_farmer': userType == 'farmer', 'nav_subdist': userType == 'subdist', 'nav_dist': userType == 'dist', 'nav_sale': userType == 'sale'}"></div>
        <!-- <cookie-consent-bar></cookie-consent-bar> -->
    </div>
</template>
<script>
/**
 * @event switchLang
 * @event logout
 * @property {object} lbl (require)
 * @property {string} activeTab (optional)
 * @property {object} profile (require)
 * @property {boolean} isLogin (require)
 * @property {ModalController} modalController (optional)
 */
// import CookieConsentBar from "@/components/Layout/CookieConsentBar/CookieConsentBar.vue";
export default {
    name: 'nav-bar-winner',// <top-bar>
    props: {
        pageName: String,
        userType: String,
        title: String,
        imageUrl: String,
    },
    components: {
        // CookieConsentBar
    },
    mounted: function () {

    },
    methods: {
        //Event
        clickBack: function () {
            this.$emit('clickBack');
        },
        //Method
    }
}
</script>
<style lang="scss" scoped>
@import "./NavBarWinner.scss";
</style>
